import { render, staticRenderFns } from "./ProductQuantityArea.vue?vue&type=template&id=b3ca9aba&"
import script from "./ProductQuantityArea.vue?vue&type=script&lang=js&"
export * from "./ProductQuantityArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports